import React from 'react'
import { ServiceRequestTemplate } from '../../structure/ServiceRequestTemplate'
import {ServiceRequestHeader} from '../../structure/ServiceRequestHeader'
import {ServiceRequestFormTitle} from '../../ServiceRequestFormTitle'

export const ServiceRequestStepNotFound = ({previousUrl}: {previousUrl: string}) => {
    return <ServiceRequestTemplate>
        <ServiceRequestHeader><ServiceRequestFormTitle previousUrl={previousUrl} title="Step not found"/></ServiceRequestHeader>
    </ServiceRequestTemplate>
}